import store, { StoreActions } from "../../state/store";

export function toggleSidebarContent(contentType, previewProperties = {simulationEvent: "all"})
{
	const checklistSimulation = store.getState().checklistModule.simulationEvent;
	const sidebarContent = store.getState().uiModule.sidebarContent;

	if(checklistSimulation) // sidebar showing
	{		
		if(sidebarContent !== contentType) // but not showing the content, so set it
		{
			store.dispatch(StoreActions.ui.setSidebarContent(contentType));
		}
		else // but already showing the content, so close it
		{
			store.dispatch(StoreActions.checklist.setPreviewProperties({ simulationEvent: "" }));
		}													
	}
	else // sidebar not showing, display it
	{
		store.dispatch(StoreActions.checklist.setPreviewProperties(previewProperties));
		store.dispatch(StoreActions.ui.setSidebarContent(contentType));
	}
}